import React, { useState } from "react";
import { connect } from "react-redux";
import * as ACTIONS from "../../actions";

// MUI
import { isEmpty } from "lodash";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
// Icons
import WhatshotIcon from "@material-ui/icons/Whatshot"; // Temperature
import FilterListIcon from "@material-ui/icons/FilterList"; //F ilter
import SwapCallsIcon from "@material-ui/icons/SwapCalls"; // Flow
import SpellcheckIcon from "@material-ui/icons/Spellcheck"; // Quality

// Status Icons
import CheckCircleIcon from "@material-ui/icons/CheckCircle"; // Default
import CancelIcon from "@material-ui/icons/Cancel"; // Default
import HelpIcon from "@material-ui/icons/Help"; //Unknown
import AcUnitIcon from "@material-ui/icons/AcUnit"; //Cooling

//HOCs
import { makeStyles } from "@material-ui/core/styles";

//Utils
import { idNameTable } from "../../util";
import ClimateTable from "./ClimateTable";

//Color
import { deepOrange, green } from "@material-ui/core/colors";
import { push } from "connected-react-router";

//Styles
const useStyles = makeStyles(theme => ({
  root: {},
  container: {
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  label: {
    display: "flex",
    justifyContent: "center",
    padding: ".5rem"
  }
}));

const icons = [
  {
    label: "Temperature",
    icon: <WhatshotIcon />,
    value: "temperature"
  },
  {
    label: "Air Filter",
    icon: <FilterListIcon />,
    value: "airFilter"
  },
  {
    label: "Air Flow",
    icon: <SwapCallsIcon />,
    value: "airFlow"
  },
  {
    label: "Air Quality",
    icon: <SpellcheckIcon />,
    value: "airQuality"
  }
];

const getStatusIcon = status => {
  switch (status) {
    case "UNKNOWN": {
      return <HelpIcon />;
    }

    case "heating": {
      return <WhatshotIcon />;
    }

    case "cooling": {
      return <AcUnitIcon />;
    }

    case true: {
      return <CheckCircleIcon style={{ color: green[300] }} />;
    }

    default: {
      return <CheckCircleIcon style={{ color: green[300] }} />;
    }
  }
};

// Main
const ClimateStepper = props => {
  const { data, reroute } = props;
  const classes = useStyles();
  const [active, setActive] = useState(["temperature"]);

  if (!data[0]) {
    return <div />;
  }

  let table = {};
  if (isEmpty(props.idNameTable)) {
    table = idNameTable(data);
    props.updateTable(table);
  } else {
    table = props.idNameTable;
  }

  const filterData = (active, data) => {
    const filtered = [];
    data.forEach(building => {
      building.devices.forEach(device => {
        filtered.push(
          device.points.filter(p => active.includes(p.dataObjectType))
        );
      });
    });
    return filtered;
  };

  const handleClick = value => {
    let newArr = [...active];
    if (newArr.includes(value)) {
      newArr = active.filter(a => a !== value);
    } else {
      newArr.push(value);
    }
    setActive(newArr);
  };

  const generatedData = (data, table) => {
    let filteredData = [];
    let filteredDevices = filterData(active, data);

    filteredDevices.forEach(points => {
      if (points) {
        points.forEach(point => {
          filteredData.push({
            icon: point.didAlarm ? (
              <CancelIcon style={{ color: deepOrange[400] }} />
            ) : (
              getStatusIcon(point.status)
            ),
            point: point.name,
            device: table.devices[point.deviceId],
            building: table.buildings[point.buildingId],
            floor: table.floors[point.floorId],
            space: table.spaces[point.spaceId],
            data: point
          });
        });
      }
    });

    return filteredData;
  };

  const climateTable = generatedData(data, table);

  // Render
  return (
    <Container maxWidth="md" className={classes.root}>
      <Grid container>
        {icons.map(icon => {
          return (
            <Grid key={icon.label} item xs={6} className={classes.container}>
              <IconButton
                onClick={() => handleClick(icon.value)}
                style={{
                  background: active.includes(icon.value)
                    ? "#BCE0FD"
                    : "#CCCCCC"
                }}
              >
                {icon.icon}
              </IconButton>
              <Typography variant="subtitle1" className={classes.label}>
                {icon.label}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
      <ClimateTable data={climateTable} title="Climate" reroute={reroute} />
    </Container>
  );
};

export default connect(
  state => ({
    idNameTable: state.constants.idNameTable
  }),
  dispatch => ({
    reroute: route => dispatch(push(route)),
    updateTable: payload =>
      dispatch({
        type: ACTIONS.UPDATE_CONSTANT_ASPECT,
        aspect: "idNameTable",
        payload
      })
  })
)(ClimateStepper);
